import React from "react";
import PropTypes from "prop-types";

import {
  InfoBenefitContainerCell,
  InfoBenefitContainerContent,
  InfoBenefitContainerContentDescription,
  InfoBenefitContainerContentTitle,
  InfoBenefitContainerCellImg,
} from "./InfoBenefit.styles";
import InfoBenefitCard from "./atom/InfoBenefitCard";
import Button from "../../../shared/Button/Button";

import firstReload from "../../../../images/first_reload_2.png";
import newChip from "../../../../images/banner-prezao-free-fire.png";
import flex from "../../../../images/banner_claro_flex.png";
import pay from "../../../../images/claro_pay.png";
import promo10GB from "../../../../images/chip-prezao462x258.png";

const IMAGES = {
  FIRST_RELOAD: firstReload,
  NEW_CHIP: newChip,
  FLEX: flex,
  PAY: pay,
  PROMO_10GB: promo10GB,
};

const InfoBenefit = ({
  type,
  backgroundCell,
  backgroundContainer,
  backgrounButton,
  title,
  description,
  buttonLabel,
  onClick,
}) => {
  return (
    <InfoBenefitCard>
      <InfoBenefitContainerCell backgroundCell={backgroundCell}>
        <InfoBenefitContainerCellImg src={IMAGES[type]} alt="" />
      </InfoBenefitContainerCell>
      <InfoBenefitContainerContent backgroundContainer={backgroundContainer}>
        <InfoBenefitContainerContentTitle>{title}</InfoBenefitContainerContentTitle>
        <InfoBenefitContainerContentDescription>
          {description}
        </InfoBenefitContainerContentDescription>
        <Button
          textColor="black"
          backgroundColor={backgrounButton}
          text={buttonLabel}
          fontWeight="bold"
          onClick={() => {
            onClick({ type });
          }}
        />
      </InfoBenefitContainerContent>
    </InfoBenefitCard>
  );
};

InfoBenefit.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  backgroundCell: PropTypes.string.isRequired,
  backgroundContainer: PropTypes.string.isRequired,
  backgrounButton: PropTypes.string.isRequired,
};

export default InfoBenefit;
